import { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorComponent from './ErrorComponent';
import hasErrors from '../../../helper/form/hasErrors';

class InputComponent extends Component {
  render() {
    const {
      id,
      name,
      label,
      className,
      errors,
      readOnly,
      inputRef,
    } = this.props;

    let inputClassNames = 'form-control';
    if (this.props.value !== '') {
      inputClassNames += ' has-content';
    }

    let classNames = 'input-field';
    if (className) {
      classNames += ` ${className}`;
    }

    if (hasErrors(errors)) {
      classNames += ' has-errors';
    }

    if (!label) {
      classNames += ' no-label';
    }

    return (
      <div>
        <div className={classNames}>
          <input
            ref={inputRef}
            value={this.props.value || ''}
            type="text"
            name={name}
            id={id}
            readOnly={readOnly}
            onChange={this.props.onChangeHandler}
            onKeyUp={this.props.onKeyUpHandler}
            onBlur={this.props.onBlurHandler}
            className={inputClassNames}
            maxLength={this.props.maxLength}
            onPaste={this.props.onPasteHandler}
          />
          {label && <label htmlFor={id}>{label}</label>}
        </div>
        <ErrorComponent errors={errors} />
      </div>
    );
  }
}

InputComponent.propTypes = {
  id: PropTypes.string,
  inputRef: PropTypes.shape(),
  readOnly: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  onChangeHandler: PropTypes.func,
  onKeyUpHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
  onPasteHandler: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
};

InputComponent.defaultProps = {
  id: null,
  className: null,
  readOnly: false,
  label: null,
  value: '',
  maxLength: null,
  onChangeHandler: () => {},
  onKeyUpHandler: () => {},
  onBlurHandler: () => {},
  onPasteHandler: () => {},
  errors: null,
  inputRef: null,
};

export default InputComponent;
